import React from 'react';
import img1 from "../assets/images/AboutBanner.jpg";

const About = () => {
  return (
    <div
      className="relative bg-cover bg-center min-h-screen flex items-center justify-center  lg:min-h-[80vh] "
      style={{
        backgroundImage: `url(${img1})`,
      }} // Background image
    >
      {/* Overlay for transparent background */}
      <div className="bg-white  bg-opacity-50 w-75 lg:w-2/4 p-8 absolute lg:right-12 end shadow-lg">
        <h2 className="text-3xl md:text-4xl font-bold text-[#54BD95] text-center md:text-left">
          At Placezio Estate
        </h2>
        <p className="mt-4  leading-relaxed text-black md:text-left">
          Discover a range of options tailored to meet your real estate needs. From residential properties to commercial spaces, we provide personalized services that cater to your unique requirements. Our dedicated team is committed to helping you find the perfect property, whether you're looking to buy, rent, or invest. With our extensive listings and expert guidance, your dream home or investment opportunity is just a step away.
        </p>
        <p className="mt-4  leading-relaxed text-black md:text-left md:block hidden">
          <b>Extensive Listings</b>: Discover a wide range of properties, from budget-friendly options to premium offerings. <br />
          <b>Verified Properties</b>: We ensure all listings are thoroughly verified, giving you peace of mind with every transaction. <br />

          <b>Handpicked Projects</b>: Explore exclusive societies like Sushant Golf City , Vrindavan Yojna, Eldeco City showcasing top-notch facilities and prime locations in lucknow.
        </p>
        {/* Button (optional) */}

      </div>
    </div>
  );
};

export default About;
